import React from 'react';
import PropTypes from 'prop-types';

import './style.less';

export default class Image extends React.Component {
  static propTypes = {
    src: PropTypes.string,
    image: PropTypes.object,
    className: PropTypes.string,
    role: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string,
    stretchAndCrop: PropTypes.bool,
    onClick: PropTypes.func
  };

  constructor(props) {
    super(props);

    if (!props.src && !props.image) {
      console.error('Error: invalid image props passed to the Image component');
    }
    if (props.src && props.image) {
      console.error('Error: Image component has too much information!');
    }
  }

  render() {
    if (!this.props.src && !this.props.image) {
      return null;
    }

    let role = this.props.role;
    if (!role && !this.props.alt) role = "presentation";

    let classNames = ['image-component'];
    if (this.props.className) classNames.push(this.props.className);
    if (this.props.stretchAndCrop) classNames.push('stretch-and-crop');

    let src = this.props.src;

    let style = {};

    if (this.props.image) {
      src = this.props.image.url;

      if (this.props.width && this.props.height) {
        let boundingAspectRatio = this.props.width / this.props.height;
        style.width = this.props.width;
        style.height = this.props.height;

        if (this.props.image.width && this.props.image.height) {
          let aspectRatio = this.props.image.width / this.props.image.height;

          if (aspectRatio > boundingAspectRatio) {
            classNames.push('landscape');
          } else if (aspectRatio < boundingAspectRatio) {
            classNames.push('portrait');
          }
        }
      }
    }

    let params = {
      src: src,
      alt: this.props.alt,
      role
    };

    let divParams = {
      style: style,
      onClick: this.props.onClick
    };

    /* eslint-disable jsx-a11y/img-has-alt */
    return (
      <div className={classNames.join(' ')} {...divParams}>
        <img {...params}/>
      </div>
    );
    /* eslint-enable jsx-a11y/img-has-alt */
  }
}




/** WEBPACK FOOTER **
 ** ./src/components/Image/index.jsx
 **/